export default __webpack_public_path__ + "static/media/Thumbnailv3.824a37c0.jpg";